import { ActionTree } from "vuex";
import { AuthState } from "./auth.module";
import { RootState } from "..";
import { MUTATIONS } from "@/constants/mutations";
import { LoginForm } from "@/interfaces/auth/login-form.model";
import { authRequests } from "@/https/auth.https";
import router from "@/router";
import { setToken } from "@/Utils/authServiceCookie";

function getAuthErrorMessage(error: unknown): string {
  if (typeof error !== "object" || error === null) {
    return "خطایی در ورود رخ داد؛ دوباره تلاش کنید";
  }

  const candidate = error as {
    response?: { data?: { message?: unknown } };
    message?: unknown;
  };
  const responseMessage = candidate.response?.data?.message;
  if (typeof responseMessage === "string" && responseMessage.length > 0) {
    return responseMessage;
  }
  if (typeof candidate.message === "string" && candidate.message.length > 0) {
    return candidate.message;
  }
  return "خطایی در ورود رخ داد؛ دوباره تلاش کنید";
}

export const AUTH_ACTIONS: ActionTree<AuthState, RootState> = {
  // loading
  toggleLoading(context, loading: boolean): void {
    context.commit(MUTATIONS.auth.toggleLoading, loading);
  },
  // toggle authentication status
  toggleAuthenticationStatus(context, status: string): void {
    context.commit(MUTATIONS.auth.toggleAuthenticationStatus, status)
  },
  // login form
  async submitLoginForm(context, loginForm: LoginForm): Promise<void> {
    context.commit(MUTATIONS.auth.toggleLoading, true);
    try {
      const response = await authRequests.LoginAdmin(loginForm);
      if (response.data?.status !== 200 && response.data?.status !== 201) {
        throw new Error(response.data?.message || "درخواست ورود ناموفق بود");
      }
      const accessToken = response.data?.data?.access_token;
      if (!accessToken) {
        throw new Error("ورود ناموفق بود؛ توکن دسترسی از سرور دریافت نشد");
      }
      if (await setToken(accessToken)) {
        await router.push({ name: "Services" });
      }
    } catch (error) {
      context.dispatch("app/updateToastModal", {
        status: true,
        type: "danger",
        message: getAuthErrorMessage(error),
      }, { root: true });
    } finally {
      context.commit(MUTATIONS.auth.toggleLoading, false);
    }
  },
};
